module.exports = __webpack_public_path__ + "static/media/delete-icon.d3a1a84d.svg";